import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { sendEvent } from './utils/analytics';
import Skeleton from './Skeleton';

const SignupModal = () => {
  const [isLoading, setIsLoading] = useState(true);
  
  const baseTitle = 'Sign Up | Adam Ten';
  const description = 'Sign up for Adam Ten\'s newsletter and stay updated with the latest news, releases, and tour dates.';
  const currentUrl = 'https://www.adam-ten.com/signup';

  // Track modal open event with Google Analytics (only if consent is given)
  useEffect(() => {
    sendEvent({
      category: 'Modal',
      action: 'Opened Signup Modal',
      label: 'Signup Modal',
    });
  }, []);

  // Load Laylo SDK script and handle loading state
  useEffect(() => {
    // Check if script is already loaded
    const existingScript = document.getElementById('laylo-sdk-script');
    
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'laylo-sdk-script';
      script.src = 'https://embed.laylo.com/laylo-sdk.js';
      script.async = true;
      
      script.onload = () => {
        console.log('Laylo SDK loaded');
        // Give the iframe time to load content
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      };
      
      script.onerror = () => {
        console.error('Failed to load Laylo SDK');
        setIsLoading(false);
      };
      
      document.head.appendChild(script);
    } else {
      // Script already loaded, check if iframe has content
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }

    return () => {
      // Don't cleanup script on unmount - keep it for subsequent opens
    };
  }, []);

  return (
    <div className="signup-modal max-width">
      <Helmet>
        <title>{baseTitle}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={baseTitle} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={baseTitle} />
        <meta name="twitter:description" content={description} />
        <link rel="canonical" href={currentUrl} />
        <meta property="og:url" content={currentUrl} />
      </Helmet>

      <h2>Sign Up</h2>
      <p>Stay up to date with the latest news, releases, and tour dates from Adam Ten.</p>

      <div className="laylo-embed-container">
        {isLoading && (
          <Skeleton height="190px" width="100%" className="laylo-skeleton" />
        )}
        
        <div style={{ display: isLoading ? 'none' : 'block' }}>
          <iframe 
            id="laylo-drop-EVLke"
            frameBorder="0"
            scrolling="no"
            allow="web-share"
            allowTransparency="true"
            style={{
              width: '1px',
              minWidth: '100%',
              maxWidth: '1000px',
              maxHeight: '200px'
            }}
            src="https://embed.laylo.com?dropId=EVLke&color=272727&minimal=false&theme=light"
            title="Adam Ten Newsletter Signup"
          />
        </div>
      </div>
    </div>
  );
};

export default SignupModal;
